<template>
    <div class="product-add pb50" v-loading="loading">
        <div>
            <div class="common-form">基本信息</div>
            <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item :label-width="formLabelWidth" style="display: block" label="*客户名称"><el-input v-model="formInline.customer_name" placeholder="请输入客户名称"></el-input></el-form-item>
                <el-form-item :label-width="formLabelWidth" style="display: block;" label="*联系电话"><el-input v-model="formInline.customer_mobile" placeholder="请输入联系电话"></el-input></el-form-item>
                <el-form-item :label-width="formLabelWidth" style="display: block" label="所在区域">
                    <el-select @change="provinceChange" v-model="formInline.province_name" filterable  placeholder="请选择省份">
                        <el-option
                                v-for="item in province_options"
                                :key="item.id"
                                :label="item.name"
                                :value="item">
                        </el-option>
                    </el-select>
                    <el-select @change="cityChange" v-model="formInline.city_name" filterable placeholder="请选择城市" :disabled="lock_city">
                        <el-option
                                v-for="item in city_options"
                                :key="item.id"
                                :label="item.name"
                                :value="item">
                        </el-option>
                    </el-select>
                    <el-select @change="regionChange" v-model="formInline.region_name" filterable placeholder="请选择区域" :disabled="lock_region">
                        <el-option
                                v-for="item in region_options"
                                :key="item.id"
                                :label="item.name"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label-width="formLabelWidth" style="display: block" label="*详细地址"><el-input v-model="formInline.customer_address" placeholder="请输入详细地址"></el-input></el-form-item>
                <el-form-item :label-width="formLabelWidth" label="*当前状态" prop="status" style="display: block">
                    <el-radio-group v-model="formInline.state">
                        <el-radio :label="0">待跟进</el-radio>
                        <el-radio :label="1">已跟进</el-radio>
                        <el-radio :label="2">已成交</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item :label-width="formLabelWidth" label="客户备注" prop="note" style="display: block">
                    <el-input type="textarea" v-model="formInline.customer_note"></el-input>
                </el-form-item>
                <el-form-item :label-width="formLabelWidth">
                    <el-button @click="gotoLast()">取消</el-button>
                    <el-button type="primary" @click="gotoTrue()">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import CustomerApi from '@/api/customer.js';
    export default {
        data() {
            return {
                /*左边长度*/
                formLabelWidth: '120px',
                formInline:{},
                loading: true,
                province_options:{},
                city_options:{},
                region_options:{},
                /* 城市锁 */
                lock_city:false,
                /* 区域锁 */
                lock_region:true,
            };
        },
        created() {
            this.getCustomer();
            this.getAddressList();
        },
        methods: {
            getCustomer(){
                let self = this;
                // 取到路由带过来的参数
                const Params = {};
                Params.customer_id = self.$route.query.customer_id
                CustomerApi.getCustomerData(Params,true)
                    .then(data => {
                        console.log(data)
                        self.loading = false;
                        self.formInline = data.data.list;
                        self.cityList(self.formInline.province_id)
                        if (self.formInline.city_id > 0){
                            self.lock_region = false
                            self.regionList(self.formInline.city_id);
                        }
                    })
                    .catch(error => {
                        self.loading = false;
                    })
            },
            gotoLast(){
                this.$router.push('/plus/customer/index');
            },
            /* 省市区 */
            getAddressList(){
                let self = this;
                CustomerApi.provinceList('',true)
                    .then(data => {
                        console.log(data)
                        self.province_options = data.data.list;
                    })
                    .catch(error => {

                    })
            },
            provinceChange(selVal){
                let self = this
                self.formInline. province_name = selVal.name
                self.formInline. province_id = selVal.id
                self.formInline.city_name = ""
                self.formInline.city_id = ""
                self.formInline.region_id = ""
                if (!self.lock_region){
                    self.lock_region = true
                    self.formInline.region_name = ""
                }
                self.cityList(selVal.id)
            },
            cityList(id){
                let self = this;
                let Params = {}
                Params.province_id = id
                CustomerApi.city_list(Params,true)
                    .then(data => {
                        self.city_options = data.data.list
                    })
                    .catch(error =>{

                    });
            },
            cityChange(selVal){
                let self = this
                self.formInline.city_name = selVal.name
                self.formInline.city_id = selVal.id
                self.formInline.region_name = ""
                self.formInline.region_id = ""
                if (self.lock_region){
                    self.lock_region = false
                }
                self.regionList(selVal.id);
            },
            regionList(id){
                let self = this;
                let Params = {}
                Params.region_id = id
                CustomerApi.region_list(Params,true)
                    .then(data => {
                        console.log(data)
                        self.region_options = data.data.list
                    })
                    .catch(error =>{

                    });
            },
            regionChange(selVal){
                let self = this
                self.formInline.region_name = selVal.name
                self.formInline.region_id = selVal.id
                /* 层级太深，需要手动刷新渲染 */
                self.$forceUpdate();
            },
            /*  保存 */
            gotoTrue(){
                let self = this;
                let Params = self.formInline;
                CustomerApi.get_edit(Params,true)
                    .then(data => {
                        self.loading = false;
                        this.$message({
                            type: 'success',
                            message: data.msg
                        });
                        this.$router.back(-1);
                    })
                    .catch(error => {
                        self.loading = false;
                    })
            }

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/plus/customer/customer/edit.vue